<template>
  <div>
    <el-dialog
      class="custom-dialog"
      :title="dataList.title || '--'"
      :visible.sync="dataList.show || false"
      :width="dataList.width"
      :fullscreen="dataList.fullscreen || false"
      :top="dataList.top || '0'"
      :modal="dataList.modal || true"
      :modal-append-to-body="dataList.modalAppendToBody || false"
      :append-to-body="dataList.appendToBody || false"
      :lock-scroll="dataList.lockScroll || true"
      :custom-class="dataList.customClass"
      :close-on-click-modal="dataList.closeOnClickModal"
      :close-on-press-escape="dataList.closeOnPressEscape"
      :show-close="dataList.showClose"
      :before-close="dataList.beforeClose"
      :center="dataList.center || false"
      :destroy-on-close="dataList.destroyOnClose || false"
      @open="(v) => baseFn(v, 'open')"
      @opened="(v) => baseFn(v, 'opened')"
      @close="(v) => baseFn(v, 'close')"
      @closed="(v) => baseFn(v, 'closed')">
      <div v-loading="dataList.loading" @scroll="scrollView">
        <div class="dialogContent">
          <slot name="dialogSlot" :scope="dataList" />
        </div>
      </div>
      <div v-if="dataList.confirmFn" class="dialogBtn" slot="footer">
        <slot name="footer">
          <el-button plain @click="dataList.beforeClose">{{ dataList.cancelTxt || "取消" }}</el-button>
          <el-button
            type="primary"
            :disabled="dataList.disabled"
            :loading="dataList.btnLoading"
            @click="(v) => baseFn(v, 'confirmFn')">
            {{ dataList.confirmTxt || "提交" }}
          </el-button>
        </slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogContainer",
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dataList: this.value,
    };
  },
  watch: {
    // 监听父组件数据变化时重新渲染弹框
    dataList: {
      handler(val, oldval) {
        this.$nextTick(() => {
          if (this.$refs.scrollbar) {
            this.$refs.scrollbar._ps_.update();
            this.$refs.scrollbar.scrollTop = 0;
          }
          this.dataList = val;
        });
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.$refs.scrollbar) {
      this.$refs.scrollbar._ps_.destroy();
      this.$refs.scrollbar._ps_ = null;
    }
  },
  methods: {
    scrollView() {
      this.$emit("scroll");
    },
    // 公用方法
    baseFn(v, fn) {
      if (this.dataList[fn]) {
        this.dataList[fn]();
      }
    },
  },
};
</script>
<style lang="scss">
.custom-dialog {
}
</style>
